module.exports = __webpack_public_path__ + "img/evrice_rad.96513454.svg";